const SECTIONS = [
  {
    h: "1. Information We Collect",
    p: "We collect the information you provide when registering (name, email, password) and managing profiles, as well as usage data such as watch history, watch progress, your list, device information and subscription plan.",
  },
  {
    h: "2. How We Use Your Information",
    p: "We use your data to provide and personalise the Service — including recommendations, Continue Watching, billing for your subscription, securing your account, and enforcing content-protection and anti-piracy measures (including stream watermarking with your account identity).",
  },
  {
    h: "3. Cookies & Sessions",
    p: "We use secure, httpOnly cookies to keep you signed in (access and refresh tokens). These are essential for the Service to function and are not used for third-party advertising tracking.",
  },
  {
    h: "4. Advertising Data",
    p: "On the ad-supported Basic tier, limited data may be used to serve advertisements. Upgrading to a paid tier removes ads. We do not sell your personal information.",
  },
  {
    h: "5. Data Security",
    p: "Passwords are hashed with bcrypt and never stored in plain text. We apply brute-force protection and industry-standard safeguards. No method of transmission is 100% secure, but we work to protect your data.",
  },
  {
    h: "6. Your Rights",
    p: "You may access, update or delete your profiles and account information at any time from the Account page. You can request full deletion of your account by contacting support.",
  },
  {
    h: "7. Data Retention",
    p: "We retain your information for as long as your account is active or as needed to provide the Service and comply with legal obligations.",
  },
  {
    h: "8. Contact",
    p: "For privacy questions or data requests, contact privacy@goldenscreen.mm.",
  },
];

export default function Privacy() {
  return (
    <div className="bg-ink min-h-screen pt-24 px-4 sm:px-12 pb-20">
      <div className="max-w-3xl mx-auto animate-fade-up">
        <h1 className="font-display text-4xl sm:text-5xl font-black mb-2">Privacy Policy</h1>
        <p className="text-white/50 text-sm mb-10">Last updated: June 2026</p>
        <div className="space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-xl font-bold mb-2 text-gold">{s.h}</h2>
              <p className="text-white/75 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
